import { render } from "./Attend.vue?vue&type=template&id=4884fe4b"
import script from "./Attend.vue?vue&type=script&lang=js"
export * from "./Attend.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__